// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export default {
  type: 'light',
  primary: {
    main: '#466282',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#ffb039',
    contrastText: '#000000',
  },
  text: {
    secondary: 'rgba(0,0,0,0.6)',
  },
  error: {
    main: '#d32f2f',
    light: '#ef5350',
    dark: '#c62828',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#ed6c02',
    dark: '#e65100',
    light: '#ff9800',
    contrastText: '#000000',
  },
  info: {
    main: '#0288d1',
    dark: '#01579b',
    light: '#03a9f4',
    contrastText: '#000000',
  },
  success: {
    main: '#2e7d32',
    dark: '#1b5e20',
    light: '#4caf50',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#FAFAFA',
  },
  microsoft: {
    main: '#FFFFFF',
    contrastText: '#5E5E5E',
  },
  appbar: {
    main: '#FFFFFF',
    contrastText: '#000000',
  },
  login: {
    main: '#EBE7E2',
  },
  copilot: {
    backgroundColor: '#FFFFFF',
    bubbleTextColor: '#FFFFFF',
    bubbleBackground: '#304D6C',
    bubbleBorderColor: '#304D6C',
    bubbleFromUserBackground: '#E9F1FF',
    bubbleFromUserTextColor: '#000000',
    bubbleFromUserBorderColor: '#E9F1FF',
    sendBoxTextColor: '#000000',
    sendBoxBackground: '#FFFFFF',
    sendBoxBorderTop: '#EBE7E2',
    suggestedActionBackgroundColor: '#304D6C',
    suggestedActionHoverBackground: '#304D7D',
    suggestedActionActiveBackground: '#304D5B',
    suggestedActionBorderColor: '#304D6C',
    suggestedActionDisabledBackground: '#2f363b',
    suggestedActionDisabledBorderColor: '#2f363b',
    suggestedActionTextColor: '#000000',
    botAvatarImage: '/smart_toy_b.png',
  },
};
